import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "content"]

  connect() {
    this.buttonTargets.forEach((button, index) => {
      button.setAttribute("aria-expanded", "false")
      this.contentTargets[index].hidden = true
      this.contentTargets[index].style.height = '0px'
    })

    // Add resize event listener
    window.addEventListener('resize', this.handleResize.bind(this));
  }

  toggle(event) {
    const button = event.currentTarget
    const content = button.parentElement.nextElementSibling
    const isExpanded = button.getAttribute("aria-expanded") === "true"

    button.setAttribute("aria-expanded", !isExpanded)
    if (isExpanded) {
      content.style.height = '0px'
      setTimeout(() => {
        content.hidden = true
      }, 300)
    } else {
      content.hidden = false
      content.style.height = content.scrollHeight + 'px'
    }
  }

  handleResize() {
    this.contentTargets.forEach((content) => {
      if (!content.hidden) {
        content.style.height = 'auto'; // Temporarily set to auto to get the new scrollHeight
        const scrollHeight = content.scrollHeight;
        content.style.height = `${scrollHeight}px`; // Set to the new scrollHeight
      }
    });
  }
}
